import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UploadTypes from 'Upload/UploadTypes';
import LandingPageFullWidthUploadPanelCTA from 'LandingPageFullWidthUploadPanelCTA';
import LandingPagePhotoToPDFModal from 'LandingPagePhotoToPDFModal';
import FullWidthUploadPanelRadioButtons from './FullWidthUploadPanelRadioButtons';


export default class EditPDFLandingPageFullWidthUploadPanel extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      uploadType: UploadTypes.FreeWrite,
    };

    this.getCTAAndRadioButtons = this.getCTAAndRadioButtons.bind(this);
    this.templateOptionClick = this.templateOptionClick.bind(this);
    this.pdfOnlyClick = this.pdfOnlyClick.bind(this);
    this.rearrangePagesClick = this.rearrangePagesClick.bind(this);
    this.getSubheader = this.getSubheader.bind(this);
    this.onUploadDrop = this.onUploadDrop.bind(this);
    this.activatePDFOnlyButton = this.activatePDFOnlyButton.bind(this);
    this.activateRearrangePagesButton = this.activateRearrangePagesButton.bind(this);
    this.activateTemplateUploadButton = this.activateTemplateUploadButton.bind(this);
  }

  componentDidMount() {
    // Track default radio button selection
    window._track('Edit PDF Only', 'Edit PDF Landing Page');
  }

  componentDidUpdate() {
    switch (this.state.uploadType) {
      case UploadTypes.FreeWrite:
        this.activatePDFOnlyButton();
        break;
      case UploadTypes.Rearrange:
        this.activateRearrangePagesButton();
        break;
      case UploadTypes.Template:
        this.activateTemplateUploadButton();
        break;
      default:
        break;
    }
  }

  onUploadDrop() {
    let uploadTrackingType;
    switch (this.state.uploadType) {
      case UploadTypes.Template:
        uploadTrackingType = 'Add Fillable Fields';
        break;
      case UploadTypes.FreeWrite:
        uploadTrackingType = 'Edit PDF Only';
        break;
      case UploadTypes.Rearrange:
        uploadTrackingType = 'Edit Pages';
        break;
      default:
        break;
    }
    window._track(`Drag and Drop Upload Zone | ${uploadTrackingType}`, 'Edit PDF Landing Page');
  }

  getSubheader() {
    const subHeaderClasses = classNames(
      'large-upload-panel-sub-header',
      { 'subheader-after-cta': this.props.isTemplateOptionAvailable },
    );

    const isTemplateUpload = this.state.uploadType === UploadTypes.Template;
    const templateOptionSubheader = 'Upload any PDF or Word Document';
    const defaultSubheader = 'Upload any PDF, Word Document, or Image';
    const subHeader = isTemplateUpload ? templateOptionSubheader : defaultSubheader;

    return <p className={subHeaderClasses}>{subHeader}</p>;
  }

  getCTAAndRadioButtons() {
    let elements;
    const subHeader = {
      element: this.getSubheader(),
      key: 'subheader',
    };
    const cta = {
      element: (
        <LandingPageFullWidthUploadPanelCTA
          ctaId={this.props.ctaId}
          ctaOnClick={() => { window._track('Upload a File to Edit', 'Edit PDF Landing Page'); }}
          ctaText="Upload a File to Edit"
        />
      ),
      key: 'cta',
    };
    const radioButtons = {
      element: (
        <FullWidthUploadPanelRadioButtons
          isTemplateOptionAvailable={this.props.isTemplateOptionAvailable}
          pdfOnlyClick={this.pdfOnlyClick}
          rearrangePagesClick={this.rearrangePagesClick}
          templateOptionClick={this.templateOptionClick}
        />
      ),
      key: 'radioButtons',
    };

    if (this.props.isTemplateOptionAvailable) {
      elements = [radioButtons, cta, subHeader];
    } else {
      elements = [subHeader, cta, radioButtons];
    }

    return (
      <div className="subheader-cta-radio-wrapper">
        {elements.map(e => (
          <React.Fragment key={e.key}>
            {e.element}
          </React.Fragment>
        ))}
      </div>
    );
  }

  activatePDFOnlyButton() {
    window.Upload.activateUploadButtonById(this.props.ctaId);
    window.UploadDragAndDrop.setUrl('/free-write/scripts/upload_pdf.php');
  }

  activateRearrangePagesButton() {
    window.Upload.activateUploadButtonById(
      this.props.ctaId,
      UploadTypes.Rearrange,
      `${window.API_URL}/temporary-document`,
    );
    window.Upload.type = UploadTypes.Rearrange;
    window.UploadDragAndDrop.setUrl('/free-write/scripts/upload_pdf.php');
  }

  activateTemplateUploadButton() {
    window.Upload.activateUploadButtonById(
      this.props.ctaId,
      'custom-template',
      `${window.API_URL}/custom-template`,
      true,
      ['application/msword', 'application/pdf', 'text/plain'],
    );
    window.UploadDragAndDrop.setUrl(`${window.API_URL}/custom-template`);
    window.UploadDragAndDrop.setUserParams();
  }

  pdfOnlyClick() {
    this.activatePDFOnlyButton();
    window._track('Edit PDF Only', 'Edit PDF Landing Page');
    this.setState({ uploadType: UploadTypes.FreeWrite });
  }

  rearrangePagesClick() {
    this.activateRearrangePagesButton();
    window._track('Edit Pages', 'Edit PDF Landing Page');
    this.setState({ uploadType: UploadTypes.Rearrange });
  }

  templateOptionClick() {
    this.activateTemplateUploadButton();
    window._track('Template Builder', 'Edit PDF Landing Page');
    this.setState({ uploadType: UploadTypes.Template });
  }

  render() {
    const wrapperClasses = classNames(
      { 'template-option-available': this.props.isTemplateOptionAvailable },
    );

    return (
      <div className={`large-upload-panel-upload-section-wrapper ${wrapperClasses}`}>
        <div className="upload-wrap edit-pages-upload-wrap hide-for-photos">
          <form id="dropzoneUploader" className="uploader">
            <div className="alert alert-error uploader-error">Error</div>
            <div
              className="uploader-area edit-pages-uploader-area"
              onDrop={this.onUploadDrop}
            >
              <img
                src="/images/blue-doc-icon.png"
                alt="Document and Arrow Icon"
                className="large-upload-panel-document-icon"
              />
              <h3 className="large-upload-panel-header">{this.props.headerCopy}</h3>
              {this.getCTAAndRadioButtons()}
            </div>
          </form>
        </div>
        <LandingPagePhotoToPDFModal />
      </div>
    );
  }
}

EditPDFLandingPageFullWidthUploadPanel.defaultProps = {
  headerCopy: 'Free PDF Editor',
  isTemplateOptionAvailable: false,
};

EditPDFLandingPageFullWidthUploadPanel.propTypes = {
  ctaId: PropTypes.string.isRequired,
  headerCopy: PropTypes.string,
  isTemplateOptionAvailable: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src-react/EditPDFLandingPage/EditPDFLandingPageFullWidthUploadPanel.jsx